import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
} from "react-icons/di";
import {
  SiRedis,
  SiSequelize,
  SiPostgresql,
  SiNestjs,
  SiTypescript,
  SiExpress,
  SiAngular,
  SiAwslambda,
  SiAmazonaws,
  SiGraphql,
  SiDocker,
  SiOpenai,
  SiOpensearch,
  SiElasticsearch,
  SiFastapi,
  SiKoa,
  SiSqlalchemy,
} from "react-icons/si";
import { TbBrandNextjs } from "react-icons/tb";
import AnthropicIcon from "./AnthropicIcon";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiKoa />
        <span className="hover-text">Koa</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiNestjs />
        <span className="hover-text">Nest Js</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <TbBrandNextjs />
        <span className="hover-text">Next Js</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiFastapi />
        <span className="hover-text">FastApi</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <DiJavascript1 />
        <span className="hover-text">Javascript</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiTypescript />
        <span className="hover-text">Typescript</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <DiNodejs />
        <span className="hover-text">Node Js</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <DiReact />
        <span className="hover-text">React</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiExpress />
        <span className="hover-text">Express</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <DiMongodb />
        <span className="hover-text">Mongo Db</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiAngular />
        <span className="hover-text">Angular</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiSequelize />
        <span className="hover-text">Sequelize</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiAwslambda />
        <span className="hover-text">Lambda Functions</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiRedis />
        <span className="hover-text">Redis</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiPostgresql />
        <span className="hover-text">Postgresql</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <DiPython />
        <span className="hover-text">Python</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiSqlalchemy />
        <span className="hover-text">SQLAlchemy</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiAmazonaws />
        <span className="hover-text">AWS</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiGraphql />
        <span className="hover-text">GraphQL</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiElasticsearch />
        <span className="hover-text">Elastic Search</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiOpensearch />
        <span className="hover-text">Open Search</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiOpenai />
        <span className="hover-text">Open AI</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <AnthropicIcon />
        <span className="hover-text">Anthropic</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <span className="small-text">MCP</span>
        <span className="hover-text">Model Context Protocol</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <SiDocker />
        <span className="hover-text">Docker</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <span className="small-text">TYPEORM</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <span className="small-text">Generative AI</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <span className="small-text">Langchain</span>
      </Col>
      <Col xs={6} md={3} lg={2} className="tech-icons">
        <span className="small-text">Vector DBs</span>
      </Col>
    </Row>
  );
}

export default Techstack;
